import { createReducer } from 'helpers'
import { get } from 'lodash'

export default createReducer({
  windowLoaded: false,
  messageType: null,
  message: '',
  suffixes: {
    profile: '',
    settings: ''
  },
  allVenues: []
}, {
  FIND_ALL_VENUES: { onSuccess: (state, { result }) => ({ allVenues: result || [] }) }
}, {
  WINDOW_LOADED: (state, action) => ({ ...state, windowLoaded: true, lineData: state.lineData || action.data }),
  SEND_MESSAGE: (state, { messageType, message, duration }) => ({ ...state, messageType, message, duration }),
  PATH_UPDATE: (state, { location }) => {
    const key = get(location.pathname.split('/'), 1)
    return {
      ...state,
      suffixes: { ...state.suffixes,
        [key]: location.pathname.replace(`/${key}`, '')
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/redux/appReducer.js